import { render, staticRenderFns } from "./TournamentMain.vue?vue&type=template&id=2f995b46&"
import script from "./TournamentMain.vue?vue&type=script&lang=js&"
export * from "./TournamentMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports